import * as React from 'react';
import { Routes, Route, } from "react-router-dom";
import DocusignCallBack from './Pages/DocusignCallBack/DocusignCallBack';
import DocusignCompleted from './Pages/DocuSignCompleted/DocusignCompleted';
import Form8821 from './Pages/Form8821/Form8821';
import UserManagement from './Pages/UserManagement/UserManagement';
import Dashboard from './Pages/Dashboard/Dashboard';
import NewDashboard from './Pages/Dashboard/NewDashboard';
import CaseDashboard from './Pages/Dashboard/CaseDashboard';
import Login from './Pages/Login/Login';
import PDFUploader from './Pages/PDFUploader/PDFUploader';
import ExpenseValidation from './Pages/ExpenseValidation/ExpenseValidation';
import Form433DResubmission from './Pages/Form433DResubmission/Form433DResubmission';
import EligiblePlans from './Pages/EligiblePlans/EligiblePlans';
import InValidateForm8821 from './Pages/InValidateForm8821/InValidateForm8821';
import SubscriptionsList from './Pages/SubscriptionsList/SubscriptionsList';
import ManualAssistance from './Pages/ManualAssistance/ManualAssistance';
import UserProgress from './Pages/UserProgress/UserProgress';
import UserLoanRejection from './Pages/UserLoanRejection/UserLoanRejection';
import IRSInterestDetails from './Pages/IRSInterestDetails/IRSInterestDetails';
import TermsAndCondition from './Pages/TermsAndCondition/TermsAndCondition';
import RefundTermsAndCondition from './Pages/RefundTermsAndCondition/RefundTermsAndCondition';
import TranscriptsLedgerDefinitions from './Pages/TranscriptsLedgerDefinitions/TranscriptsLedgerDefinitions';
import CSEDDisclaimer from './Pages/CSEDDisclaimer/CSEDDisclaimer';
import ReviewExpenseProofs from './Pages/ReviewExpenseProof/ReviewExpenseProof';
import PlaidRedirect from './Pages/PlaidRediect/PlaidRedirect';
import DeleteAccount from "./Pages/DeleteAccount/DeleteAccount";
import InstallmentAgreement from "./Pages/InstallmentAgreement/InstallmentAgreement";
import InstallmentAgreementGuide from "./Pages/InstallmentAgreementGuide/InstallmentAgreementGuide"; import ReviewPaymentForms from './Pages/ReviewPaymentForms/ReviewPaymentForms';
import KwongClaim from './Pages/KwongClaim/KwongClaim';
import KwongClaimManagement from './Pages/KwongClaim/KwongClaimManagement';
import RevenueDetails from './Pages/RevenueDetails/RevenueDetails';
import Form433AReview from './Pages/Form433AReview/Form433AReview';
import Form433AReviewList from './Pages/Form433AReview/Form433AReviewList';
import SupportTickets from './Pages/SupportTickets/SupportTickets';


export default (
    <Routes>
        <Route path="/kwongClaimsDetails" element={<KwongClaimManagement />} />
        <Route path="/kwongClaims" element={<KwongClaim />} />
        <Route path="/reviewPayment" element={<ReviewPaymentForms />} />
        <Route path="/reviewProofs" element={<ReviewExpenseProofs />} />
        <Route path="/interestDetails" element={<IRSInterestDetails />} />
        <Route path="/transcriptsledger" element={<TranscriptsLedgerDefinitions />} />
        <Route path="/cseddisclaimer" element={<CSEDDisclaimer />} />
        <Route path="/userProgress" element={<UserProgress />} />
        <Route path="/userLoanRejection" element={<UserLoanRejection />} />
        <Route path="/invalidate" element={<InValidateForm8821 />} />
        <Route path="/rejectedUsers" element={<ManualAssistance />} />
        <Route path="/subscriptionList" element={<SubscriptionsList />} />
        <Route path="/supportTickets" element={<SupportTickets />} />
        <Route path="/chatGpt/pdfUpload" element={<PDFUploader />} />
        <Route path="/getAllEligiblePlans" element={<EligiblePlans />} />
        <Route path="/checkIrsResponse" element={<Form433DResubmission />} />
        <Route path="/expenseValidation" element={<ExpenseValidation />} />
        <Route path="/form8821" element={<Form8821 />} />
        <Route path="/useractions" element={<UserManagement />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/new-dashboard" element={<NewDashboard />} />
        <Route path="/casedashboard" element={<CaseDashboard />} />
        <Route path="/form433AReview" element={<Form433AReviewList />} />
        <Route path="/form433AReview/details" element={<Form433AReview />} />
        {/* <Route path="/revenueDetails" element = {<RevenueDetails/>}/> */}
        <Route path="/" element={<Login />} />

        {/* No authorization is required. */}
        <Route path="/signCompleted" element={<DocusignCallBack />} />
        <Route path="/processCompleted" element={<DocusignCompleted />} />
        <Route path="/plaid" element={<PlaidRedirect />} />
        <Route path="/refundtermsAndCondition" element={<RefundTermsAndCondition />} />
        <Route path="/deleteaccount" element={<DeleteAccount />} />
        <Route path="/termsAndCondition" element={<TermsAndCondition />} />
        <Route path="/installmentagreement/:type?" element={<InstallmentAgreement />} />
        <Route path="/installmentagreementguide/:type?" element={<InstallmentAgreementGuide />} />
    </Routes>
);